import { FavoritesScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <FavoritesScreen />;
}
